import {Component, computed, inject, input} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'quote-attachments',
  templateUrl: './quote-attachments.component.html',
  standalone: false
})
export class QuoteAttachmentsComponent {
  attachments = input.required<any[]>();
  totalCount = computed(() => {
    const attachments = this.attachments();
    return attachments.length > 0 ? attachments[0].total_count : 0;
  });

  protected readonly String = String;
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  handleShowMore() {
    const quoteId = this.route.snapshot.queryParams['quote_id'];
    const url = this.router.createUrlTree(['/quote-attachments-details'], {queryParams: {quote_id: quoteId}}).toString();
    window.open(url, '_blank');
  }
}
